// Line icons for the control deck (24×24 grid, stroke = currentColor). No emoji.
export type IconName =
  | "lock" | "unlock" | "boot" | "boot-open"
  | "win-up" | "win-vent" | "win-down"
  | "snow" | "fan-off" | "shield-off" | "clock" | "power"
  | "exit" | "shield-check" | "ban";

export const PATHS: Record<IconName, string> = {
  lock:        "M6 11h12v9H6z M9 11V7a3 3 0 0 1 6 0v4 M12 15v2",
  unlock:      "M6 11h12v9H6z M9 11V7a3 3 0 0 1 5.6-1.5 M12 15v2",
  boot:        "M3 16l2.5-6h9l4 4H21v4H3z M6 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z M17 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z M14.5 10V6",
  "boot-open": "M3 16l2.5-6h9l4 4H21v4H3z M6 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z M17 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z M14.5 10l4-5",
  "win-up":    "M4 5h16v14H4z M4 12h16 M9 10l3-3 3 3",
  "win-vent":  "M4 5h16v14H4z M4 12h16 M9 16h6 M12 16v-3",
  "win-down":  "M4 5h16v14H4z M4 12h16 M9 14l3 3 3-3",
  snow:        "M12 3v18 M4.2 7.5l15.6 9 M4.2 16.5l15.6-9 M12 3l-2 2 M12 3l2 2 M12 21l-2-2 M12 21l2-2",
  "fan-off":   "M12 3v9 M7.5 6.5a7 7 0 1 0 9 0",
  "shield-off":"M12 3l8 3v6c0 4.6-3.4 8.2-8 9-4.6-.8-8-4.4-8-9V6z M9 12h6",
  clock:       "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 7v5l3 2",
  power:       "M12 4v8 M6.5 7.5a8 8 0 1 0 11 0",
  exit:        "M13 4h6v16h-6 M3 12h10 M9 8l4 4-4 4",
  "shield-check": "M12 3l8 3v6c0 4.6-3.4 8.2-8 9-4.6-.8-8-4.4-8-9V6z M9 12l2 2 4-4",
  ban:         "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M6 6l12 12",
};

export function Icon({ name, size = 22, strokeWidth = 1.7 }: { name: IconName; size?: number; strokeWidth?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  );
}
